/*
 * config.js — FONTE ÚNICA da verdade do painel (OKF).
 * Espelha os valores PÚBLICOS do cofre: jarvis/chaves_toca_da_onca.json (bloco "sistemas").
 * Regra: nunca hardcodar link/nome espalhado nas views — importar daqui.
 * Segredo NUNCA aqui (só o publishable, que é público). Secret fica no bridge (servidor).
 */
export const LOJA = "Toca da Onça Modas";

export const URLS = {
  bridge: "http://localhost:8787",              // motor local (PDV + conectores de API)
  painel: "https://painel-toca.pages.dev",      // este painel
  site: "https://tocadaoncamodas.com.br",       // loja online
  crm: "https://crm-toca.wlonik.easypanel.host", // Twenty CRM
};

// atalho usado pelo PDV e pelos conectores de marketplace
export const BRIDGE = URLS.bridge;
